import { ROUTES } from '@/models/router.model';
import { MouseEvent } from 'react';
import { Avatar } from '@/ui';
import { useGetProfile } from '../../hooks';
import { StyledLink, StyledName } from './ProfileLinkContainerStyles';

type TProfileLinkContainerProps = {
  withName?: boolean;
  onClick?: (event: MouseEvent) => void;
};

const ProfileLinkContainer = ({ withName = false, onClick }: TProfileLinkContainerProps) => {
  const { profile } = useGetProfile();
  return (
    <StyledLink path={ROUTES.PROFILE} $withName={withName} onClick={onClick}>
      <Avatar src={profile?.profile_photo} name={profile?.full_name} />
      {withName && <StyledName>{profile?.full_name}</StyledName>}
    </StyledLink>
  );
};

export default ProfileLinkContainer;
